import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/customer-orders', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/restaurant-sales/customer-orders', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const category = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/customer-orders/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchSystemSettings = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/customer-orders/system-settings', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchCompanyInfo = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/customer-orders/company-infos', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/customer-orders/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const deleteItemOrdered = (Options = {}) => {
  return httpClient
    .get(
      '/api/v1/restaurant-sales/customer-orders/delete-item-ordereds',
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchPromotions = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/customer-orders/promotions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  store,
  category,
  fetchSystemSettings,
  product,
  fetchCompanyInfo,
  deleteItemOrdered,
  fetchPromotions
}
